import type { UnclaimedGiftViewModel } from 'autogen/swagger/all';
import Card from 'components/generic/card';
import { css } from 'styled-components';
import { ColorBeauty5 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';
import { Typography } from 'components/generic/typography';
import { Button } from 'components/Button';
import UAEventTracking from 'modules/tracking/UAEventTracking';
import format from 'helpers/translations';
import { AddSingleGwp, initializeSelectGWPModal } from '../shared/helpers';

export default function UnclaimedGifts({
    model: unclaimedGifts,
    OptInGift = false
}: {
    model: UnclaimedGiftViewModel[];
    OptInGift: boolean;
}) {
    return (
        <>
            {unclaimedGifts.map((unclaimedGift) => (
                <Card
                    key={unclaimedGift.selectLinkAction.url}
                    css={css`
                        background-color: ${ColorBeauty5};
                    `}
                >
                    <Card.Content>
                        <Flex.Row justifyContent="space-between">
                            <Typography.Body as="span" size="M">
                                {format(unclaimedGift.giftText)}
                            </Typography.Body>

                            <Button
                                onClick={async () => {
                                    try {
                                        if (OptInGift) {
                                            await AddSingleGwp(unclaimedGift.selectLinkAction.url);
                                            UAEventTracking({
                                                eventCategory: 'giftLine',
                                                eventAction: 'chooseGift',
                                                eventLabel: unclaimedGift.selectText
                                            });
                                        } else {
                                            await initializeSelectGWPModal(unclaimedGift.selectLinkAction.url);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }}
                                variant="secondary"
                            >
                                {unclaimedGift.selectText}
                            </Button>
                        </Flex.Row>
                    </Card.Content>
                </Card>
            ))}
        </>
    );
}
